import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-overlock_blue",
  "use": "icon-overlock_blue-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-overlock_blue\">\n<style type=\"text/css\">\n\t#icon-overlock_blue .st0{fill:#52A8FF;}\n</style>\n<path class=\"st0\" d=\"M64.7,135.3c-19.5-19.5-19.6-51.2,0-70.7s51.2-19.6,70.7,0s19.6,51.2,0,70.7c0,0,0,0,0,0l23.6,23.6\n\tc32.5-32.5,32.5-85.3,0-117.9s-85.3-32.5-117.9,0s-32.5,85.3,0,117.9c0,0,0,0,0,0L64.7,135.3z\" />\n<path class=\"st0\" d=\"M100,183.3c9,0,17.8-1.5,26.3-4.3L100,100l-26.3,79C82.2,181.9,91,183.3,100,183.3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/overlock_blue.svg
// module id = jTlr
// module chunks = 102